import { create } from "zustand";

export const useSelectedServerVersionStore = create((set) => ({
  selectedServerVersionZustandState: "", // Initial state
  setSelectedServerVersionZustandState: (version) =>
    set({ selectedServerVersionZustandState: version }), // Action to update the state
}));

export default useSelectedServerVersionStore;
